import { exactDateFormatter } from 'src/utils/dateFormatter';

type ReportDates = {
  publicationDate: string | undefined | null;
  updatedAtDate: string | undefined | null;
  fallbackValue: string;
};

export const reportDates = ({ publicationDate, updatedAtDate, fallbackValue }: ReportDates) => {
  if (!publicationDate && !updatedAtDate) return fallbackValue;
  const fields: string[] = [];
  const updatedAtDateFormatted = exactDateFormatter(updatedAtDate, '');
  const publicationDateFormatted = exactDateFormatter(publicationDate, '');

  if (publicationDateFormatted) {
    fields.push(`<strong>Gepubliceerd op:</strong> ${publicationDateFormatted}`);
  }

  if (updatedAtDateFormatted) {
    fields.push(`<strong>Aangepast op:</strong> ${updatedAtDateFormatted}`);
  }

  return fields.join('<br />');
};
